module.exports = __webpack_public_path__ + "static/media/TipoDoc1.7c0dcb23.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/CadTipoDoc/TipoDoc1.png
// module id = 2191
// module chunks = 0